import React, { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { useTheme } from '@mui/material';
import { IconProps } from 'shared/icons/iconProps';

export default function ArrowUp({
  extColor,
  isAutoscallable = true,
  sizeKey = '20x20',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.primary;

  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5215 7.2398L14.4773 8.31665L11.166 5.10576L11.166 16.6671C11.166 17.0813 10.8303 17.4171 10.416 17.4171C10.0018 17.4171 9.66604 17.0813 9.66604 16.6671L9.66604 5.10576L6.35482 8.31665L5.3106 7.2398L10.416 2.28906L15.5215 7.2398Z"
        fill={fill}
      />
    </svg>
  );
}
